import React from 'react';

import { Prestation, PrestationOrCategoryPrice } from '@front/common/src/types/commons';
import { formatPrice } from '@front/common/src/utils/formatting';
import colors from '@front/common/src/utils/colors';

import Text from '@front/web-ui/src/components/base-text/variants/text';

import { PrestationsListElement } from '../common';

type PrestationItemProps = {
  prestation?: Prestation;
  price?: PrestationOrCategoryPrice;
};

const PrestationItem = ({ prestation, price }: PrestationItemProps) => (
  <PrestationsListElement>
    <Text>{`• ${prestation?.title || '?'}`}</Text>
    {price && <Text.SM color={colors.ink50}>{formatPrice(price.standard)}</Text.SM>}
  </PrestationsListElement>
);

export default PrestationItem;
